import { render, staticRenderFns } from "./ResourcesCategory.vue?vue&type=template&id=34380b98&scoped=true&"
import script from "./ResourcesCategory.vue?vue&type=script&lang=js&"
export * from "./ResourcesCategory.vue?vue&type=script&lang=js&"
import style0 from "./ResourcesCategory.vue?vue&type=style&index=0&id=34380b98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34380b98",
  null
  
)

export default component.exports